import React from 'react';

const Reviews = ({ content, url }) => {
  return (
    <div className="review-container">
      <p className="review-container-text">{content}</p>
      <a className="review-container-link" href={url}>
        Link to review >>>
      </a>
    </div>
  );
};

export default Reviews;
